import { apiRequest } from '@common/api/utils';
import { Select } from '@common/vanilla_ui/general';

function initializeForm(formId = 'application-form', forceProfile = true) {
  const linkedinInputId = `${formId}-linkedin-profile`;
  const normalizedPhoneInputId = `${formId}-normalized-phone`;
  const orgnameInputId = `${formId}-orgname`;
  const orgyearInputId = `${formId}-orgyear`;
  const taSubjectInputId = `${formId}-ta-subject`;
  const tshirtInputId = `${formId}-tshirt`;
  const phoneNumberInputId = `${formId}-phone-number`;
  const phoneCountryCodeInputId = `${formId}-phone-country-code`;
  const linkedinUrlRegex = /^(https?:\/\/)?(www\.)?linkedin\.com/;
  const resumeInputId = `${formId}-resume`;
  const resumePickerId = `${formId}-resume-picker`;
  const resumeFileId = `${formId}-resume-file`;
  const submitButtonId = `${formId}-submit`;
  const universityInputId = `${formId}-university`;
  const experienceYearsInputId = `${formId}-experience-years`;
  const experienceMonthsInputId = `${formId}-experience-months`;
  const positionInputId = `${formId}-position`;

  const resumeInputEl = document.getElementById(resumeInputId);
  const resumePickerEl = document.getElementById(resumePickerId);
  const resumeFileEl = document.getElementById(resumeFileId);
  const submitButtonEl = document.getElementById(submitButtonId);
  const normalizedPhoneEl = document.getElementById(normalizedPhoneInputId);
  const phoneNumberEl = document.getElementById(phoneNumberInputId);
  const orgnameInputEl = document.getElementById(orgnameInputId);
  const taSubjectInputEl = document.getElementById(taSubjectInputId);
  const tshirtInputEl = document.getElementById(tshirtInputId);
  const universityInputEl = document.getElementById(universityInputId);
  const experienceYearsInputEl = document
    .getElementById(experienceYearsInputId);
  const experienceMonthsInputEl = document
    .getElementById(experienceMonthsInputId);
  const positionInputEl = document.getElementById(positionInputId);

  let isResumeSelected = false;
  let isLinkedinConnected = false;

  if (forceProfile) {
    resumeInputEl.addEventListener('change', (event) => {
      if (event.target.value) {
        const fakePath = event.target.value;
        resumePickerEl.innerText = 'Change Resume';
        // eslint-disable-next-line prefer-destructuring
        resumeFileEl.innerText = fakePath.split('\\').reverse()[0];
        submitButtonEl.classList.remove('is-disabled');
        isResumeSelected = true;
      } else {
        if (!isLinkedinConnected) {
          submitButtonEl.classList.add('is-disabled');
        }

        resumePickerEl.innerText = 'Select Resume';
        resumeFileEl.innerText = '';
        isResumeSelected = false;
      }
    });

    const linkedinInputEl = document.getElementById(linkedinInputId);
    linkedinInputEl.addEventListener('change', (event) => {
      const url = event.target.value || '';
      if (linkedinUrlRegex.test(url.trim())) {
        submitButtonEl.classList.remove('is-disabled');
        isLinkedinConnected = true;
      } else {
        if (!isResumeSelected) {
          submitButtonEl.classList.add('is-disabled');
        }

        isLinkedinConnected = false;
      }
    });
  } else {
    submitButtonEl.classList.remove('is-disabled');
  }

  new Select(orgyearInputId, { searchable: true });

  if (taSubjectInputEl) {
    new Select(taSubjectInputId, { searchable: true });
  }

  const countryCodeSelect = new Select(
    phoneCountryCodeInputId,
    { searchable: true },
  );

  if (tshirtInputEl) {
    new Select(tshirtInputId);
  }

  if (orgnameInputEl) {
    new Select(orgnameInputId, {
      isAsync: true,
      isCreatable: true,
      loadOptions: async (keyword) => {
        const json = await apiRequest(
          'GET',
          '/get-companies',
          null,
          { params: { q: keyword } },
        );
        return json.items.map(item => ({ label: item.text, value: item.id }));
      },
    });
  }

  if (universityInputEl) {
    new Select(universityInputId, {
      isAsync: true,
      isCreatable: true,
      loadOptions: async (keyword) => {
        const json = await apiRequest(
          'GET',
          '/get-universities',
          null,
          { params: { q: keyword } },
        );
        return json.items.map(item => ({ label: item.text, value: item.id }));
      },
    });
  }

  if (experienceYearsInputEl) {
    new Select(experienceYearsInputId);
  }

  if (experienceMonthsInputEl) {
    new Select(experienceMonthsInputId);
  }

  if (positionInputEl) {
    new Select(positionInputId);
  }

  // Don't submit form unless linkedin url or resume is provided
  const formEl = document.getElementById(formId);
  formEl.addEventListener('submit', (event) => {
    if (forceProfile && !isLinkedinConnected && !isResumeSelected) {
      event.preventDefault();
    }
    phoneNumberEl.value = `${countryCodeSelect.selectedValue}-`
      + `${normalizedPhoneEl.value}`;
  });
}

export default {
  initialize: initializeForm,
};
